import styled from "styled-components/macro";

export const Container = styled.div`
  ul {
    li.invocation {
      margin-bottom: 2em;
    }
  }

  ul.snippets {
    margin-top: 0.5em;
    li {
      color: #555;
      margin-bottom: 1em;
    }
  }
`;

export const CompletionsSearchInput = styled.input`
  margin-right: 1em;
`;
